import * as React from 'react';
import { Card, Spinner } from "react-bootstrap";
import './DebitOrderDate.css';

export interface DebitOrderDetailsProps {
    debitOrderDate: {
        when: string;
        startDate: string;
        monthsActive: string;
    };
    loading?: boolean;
    onEmitChangeDebitOrderDate;
}


export class DebitOrderDate extends React.Component<DebitOrderDetailsProps> {
    constructor(props: DebitOrderDetailsProps) {
        super(props);
        
        this.handleChangeDebitOrderDate = this.handleChangeDebitOrderDate.bind(this);
    }
    
    handleChangeDebitOrderDate() {
        this.props.onEmitChangeDebitOrderDate(); 
    }
    
    public render() {
        return (
            <Card className="debit-order-date-view-card">
                <Card.Body id="DebitOrderDate">
                    <div className="p-0">
                        <p className="Credit-card pt-4 pl-4">Debit order date</p>
                        { (!this.props.loading && <>
                            <div className="px-4">
                                <div className="row">
                                    <div className="col-lg-6 col-6">
                                        <p>When</p>
                                    </div>
                                    <div className="col-lg-6 col-6">
                                        <p className="font-weight-bold text-right">{this.props.debitOrderDate?.when ? this.props.debitOrderDate.when : 'N/A'}</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-6 col-4">
                                        <p>Start date</p>
                                    </div>
                                    <div className="col-lg-6 col-8">
                                        <p className="font-weight-bold text-right">{this.props.debitOrderDate?.startDate ? this.props.debitOrderDate.startDate : 'N/A'}</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-6 col-6">
                                        <p>Months active</p>
                                    </div>
                                    <div className="col-lg-6 col-6">
                                        <p className="font-weight-bold text-right">{this.props.debitOrderDate?.monthsActive ? this.props.debitOrderDate.monthsActive : 'N/A'}</p>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <div className="col-12 mt-3 pb-3 p-0 text-center text-lg-right">
                                <button className="btn btn-outline-red mr-0 mr-md-3" id='UpdateBankingInfo' onClick={this.handleChangeDebitOrderDate}>Change debit order date</button>
                            </div>
                        </> ) ||
                        <Spinner className="d-block mx-auto mb-3" animation="border" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner> }
                    </div>
                </Card.Body>
            </Card>
        )
    }
}
